import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";
import "./DocumentList.css";
import {
    getAllDocuments,
    viewDocument,
    downloadDocumentById
} from "../../services/user-service";

const DocumentList = () => {
    const [documents, setDocuments] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        loadDocuments();
    }, []);

    const loadDocuments = () => {
        getAllDocuments()
            .then((response) => {
                setDocuments(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleView = (doc) => {
        viewDocument(doc.id)
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "application/pdf",
                });

                const url = window.URL.createObjectURL(blob);

                window.open(url, "_blank");
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleDownload = (doc) => {
        downloadDocumentById(doc.id)
            .then((response) => {
                const file = new Blob([response.data]);
                const fileURL = window.URL.createObjectURL(file);

                const link = document.createElement("a");
                link.href = fileURL;
                link.download = doc.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(fileURL);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleViewAsset = (doc) => {

        switch (doc.assetType) {

            case "Insurance":
                navigate(`/user/my-estate/insurances/${doc.assetId}`);
                break;

            case "Vehicle":
                navigate(`/user/my-estate/vehicles/${doc.assetId}`);
                break;

            case "Investment":
                navigate(`/user/my-estate/investment/${doc.assetId}`);
                break;

            case "Bank":
                navigate(`/user/my-estate/banks/${doc.assetId}`);
                break;

            case "Crypto":
                navigate(`/user/my-estate/crypto/${doc.assetId}`);
                break;

            case "Real Estate":
                navigate(`/user/my-estate/real-estate/${doc.assetId}`);
                break;

            case "Income":
                navigate(`/user/my-estate/income/${doc.assetId}`);
                break;

            case "Jewelry":
                navigate(`/user/my-estate/jewelry/${doc.assetId}`);
                break;

            case "Other Asset":
                navigate(`/user/my-estate/otherAsset/${doc.assetId}`);
                break;

            case "International Asset":

                switch (doc.internationalAssetType) {

                    case "realEstate":
                        navigate(`/user/my-estate/International_assets/realEstate/${doc.internationalAssetId}`);
                        break;

                    case "bank":
                        navigate(`/user/my-estate/International_assets/bank/${doc.internationalAssetId}`);
                        break;

                    case "investment":
                        navigate(`/user/my-estate/International_assets/investment/${doc.internationalAssetId}`);
                        break;

                    case "crypto":
                        navigate(`/user/my-estate/International_assets/crypto/${doc.internationalAssetId}`);
                        break;

                    case "insurance":
                        navigate(`/user/my-estate/International_assets/insurance/${doc.internationalAssetId}`);
                        break;

                    case "vehicle":
                        navigate(`/user/my-estate/International_assets/vehicle/${doc.internationalAssetId}`);
                        break;

                    case "income":
                        navigate(`/user/my-estate/International_assets/income/${doc.internationalAssetId}`);
                        break;

                    case "jewelry":
                        navigate(`/user/my-estate/International_assets/jewelry/${doc.internationalAssetId}`);
                        break;

                    case "otherAsset":
                        navigate(`/user/my-estate/International_assets/otherAsset/${doc.internationalAssetId}`);
                        break;

                    default:
                        alert("International Asset page not available.");
                }
                break;

            default:
                alert("Asset page not available.");
        }
    };
    return (
        <div className="document_list_main">

            <div className="document_heading">
                <h4>Documents ({documents.length})</h4>
            </div>

            <div className="document_container"
                 style={{ maxWidth: "1350px", margin: "0 auto" }}>

                {/* Header */}
                <Paper
                    sx={{ padding: 1.5 }}
                    className="document_card"
                    style={{ backgroundColor: "rgb(208,208,208)" }}
                >
                    <p className="document_row"><strong>Document</strong></p>
                    <p className="document_row"><strong>Asset Type</strong></p>
                    <p className="document_action"><strong>Action</strong></p>
                </Paper>

                {/* Data */}
                {documents.map((doc) => (

                    <Paper
                        key={doc.id}
                        sx={{ padding: 1.5 }}
                        className="document_card"
                    >

                        <p className="document_row">
                            {doc.fileName}
                        </p>

                        <p className="document_row">
                            {doc.assetType}
                        </p>

                        <div className="document_action">

                            <button
                                className="document_btn"
                                onClick={() => handleView(doc)}
                            >
                                View
                            </button>

                            <button
                                className="document_btn"
                                onClick={() => handleDownload(doc)}
                            >
                                Download
                            </button>

                            <button
                                className="document_btn_dark"
                                onClick={() => handleViewAsset(doc)}
                            >
                                View Asset
                            </button>

                        </div>

                    </Paper>

                ))}

            </div>

        </div>
    );
};

export default DocumentList;